function r(e) {
  return e;
}
export {
  r as c
};
